// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"754":"c476a344","5499":"c476a344"}[chunkId] + ".chunk.css";
};